/**
 * Роли и состояния пользователя.
 *
 * Один пользователь может иметь несколько ролей одновременно.
 *
 * Этот список — единственный источник полного множества ролей для приложения:
 * из него выводятся и серверная валидация, и форма назначения ролей. Второй
 * рукописный перечень однажды разошёлся бы с первым, и роль, существующая
 * в базе, оказалась бы недоступной в интерфейсе.
 *
 * Порядок совпадает с порядком значений перечисления `Role` в PostgreSQL:
 * новые значения добавляются только в конец.
 *
 * `WAREHOUSE`, `FLORIST` и `MANAGER` — роли производственного контура
 * (`docs/OWNER_DECISIONS.md`, `FUL-001`). Их разделы существуют, но пока
 * содержат только честные заглушки.
 */
export const ROLES = [
    'ADMIN',
    'LOGISTICIAN',
    'COURIER',
    'WAREHOUSE',
    'FLORIST',
    'MANAGER',
    'SUPERVISOR',
];
export const ROLE_LABELS = {
    ADMIN: 'Администратор',
    LOGISTICIAN: 'Логист',
    COURIER: 'Курьер',
    WAREHOUSE: 'Кладовщик',
    FLORIST: 'Флорист',
    MANAGER: 'Менеджер выдачи',
    SUPERVISOR: 'Управляющий',
};
/**
 * Состояния пользователя. Физического удаления сотрудников и курьеров не существует:
 * учётная запись переводится в `FROZEN` и может быть возвращена в `ACTIVE`.
 */
export const USER_STATUSES = ['PENDING_ACTIVATION', 'ACTIVE', 'FROZEN'];
export const USER_STATUS_LABELS = {
    PENDING_ACTIVATION: 'Ожидает активации',
    ACTIVE: 'Активен',
    FROZEN: 'Заморожен',
};
/** Тип транспорта курьера по умолчанию. */
export const VEHICLE_TYPES = ['CAR', 'FOOT'];
export const VEHICLE_TYPE_LABELS = {
    CAR: 'Автомобиль',
    FOOT: 'Пеший',
};
export function hasRole(roles, role) {
    return roles.includes(role);
}
export function hasAnyRole(roles, allowed) {
    return roles.some((role) => allowed.includes(role));
}
/** Роли, которым доступны операционные разделы логистики. */
export const OPERATIONS_ROLES = ['ADMIN', 'LOGISTICIAN', 'SUPERVISOR'];
//# sourceMappingURL=roles.js.map